function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  fill: "url(#pattern0)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "pattern0",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image0_3843_2329",
  transform: "scale(0.015625)"
})), /*#__PURE__*/React.createElement("image", {
  id: "image0_3843_2329",
  width: 64,
  height: 64,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAADk0lEQVR4nO2bP2wbVRzHP7+HE4ca0TIhYGpSZUGMsHSJsBvV+SOGuipUBFUsSIilChuLByZURUwRA2OKQHEGlBgjxWZCQkJiZGnrbAh1ShAkblJ8Pwbbl+shJ/bF9k927jO9e7/n976/753v3tPdE0LMzi6lvEQto06mnOpYON5CVTzFfV/54bsH7doMgvTcrWnBe0dEXbs2qnok4qoT7kl5c3PzIBhLBMqSmbv5qSe1z4CLooqeNLIowr8fAVfOlMEZEamXgMmTtQqKUvOSe9fmc59vFwsr0EjPAeTzeZeZz91H9AvgYt9V23FJ4V5m4cYaINC8An7+9fdlhPeO22kVqIDstutJYd8J3/ZX7+mI6HVP5V2BVPtW+hKQBplqHMrt9MLN3ypb6ysyO7uU8sZqf9A88yp8PV7f/6RUKh0OQP/AyGazyacutQp82Kzae94dvuZ07Ema48v+0SgmD1AqlQ7HvP2PgZ1m1aWDevJtp+i030opj2LyLRq5admvcDLtEF44ruCxhbCBIvKnX0RfbPvsPC/EBlgLsCY2wFqANefegIQoR62FhELbOUB67ta0SP1HQEX0+vbWxsN+xnqpIUg4X+fpc4XG3F+rDi20G9xJPQdcBiY9JNfvWC81BAnnm2iu509d0qow3lofCyT7HeulhiDhfM/9PSA2wFqANbEB1gKsiQ2wFmBNbIC1AGtiA6wFWBMbYC3AmtgAawHWxAZYC7AmNsBagDWxAdYCrIkNsBZgTWyAtQBrYgN60YkoR61y+AVr1Fi340SlJwac9II1aqzbcaKSOL3J6Zz0gjVqrBftOyG+B1gLsCbR7Vcaw044X9ftVxrDTjhfp8J4K9jJVxrDTjjfju8B4knVL6s+6rWwsxJVX8cGXH3r9fuCLgm6dPXNN77pVmC/iaqv43lAPp/3gDWA7eJGBIn9Jaq+c/8YjA2wFmCNE+Vv/0j1FUMtg0F51S97+pcT0eDOz3Q2mx3ZucDMzJ0JIONXiHvgknJUAfaaNVNPXWp1FE2YmbkzkbjwzyqNWSDA7v4FfhKAa/O5ZYV7gfY7oGVBdv7XU5Oh2jsMUzTO/OVA9d1ysfClNA8ks3BjDZXb3Q2v1XJxw3TvcGY+VwUmu/mNwlqlWPgA8F3T8tbG+yqyjP93GEl2gbut5OHZmaBWttZXFhcXvzrU8bTncQWRl9v1NFR7h1UfK/LwICWVX9bXa8HQfxQcu8Ps2nxgAAAAAElFTkSuQmCC"
}));

const SvgIconBarcode = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconBarcode, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-barcode.83ec6e11.svg";
export { ForwardRef as ReactComponent };